<template>
  <div id="jhmenu">
    <div class="topbar">
      <div class="left">
        <div id="show-menu" @click="switchShow">
          <font-icon icon="bars" />
        </div>
        <span>{{$store.state.heading}}</span>
      </div>
      <div class="right bar">
        <button v-if="$store.state.bar.exportToExcel" @click="clicked('exportToExcel')" title="Liste exportieren">
          <font-icon icon="file-excel" />
        </button>
        <button v-if="$store.state.bar.birthday" @click="clicked('birthday')" title="Geburtstage ausleiten">
          <font-icon icon="birthday-cake" />
        </button>
        <button v-if="$store.state.bar.view" @click="clicked('view')" title="Sicht �ndern">
          <font-icon :icon="['far', 'eye']" />
        </button>
        <button v-if="$store.state.bar.setting" @click="clicked('setting')" title="Einstellungen">
          <font-icon icon="cog" />
        </button>
        <button v-if="$store.state.bar.refresh" @click="clicked('refresh')" title="Aktualisieren">
          <font-icon icon="sync-alt" />
        </button>
        <input v-if="$store.state.bar.menuinputplace" :placeholder="$store.state.bar.menuinputplace" class="menuinput" v-model="menuinput" type="text"/> 
        <button v-if="$store.state.bar.add" @click="clicked('add', menuinput)" title="Hinzuf�gen">
          <font-icon icon="plus-square" />
        </button>
        <input v-if="$store.state.bar.search" placeholder="Suche" class="search" type="search" v-model="$store.state.searchTerm"/>
      </div>
    </div>
    <ul v-bind:class="classLeftBar" @mouseover="mouseOverLeftBar" @mouseleave="mouseLeaveLeftBar">
      <li>
        <router-link to="/member" 
        :event="$store.state.user.permissions.member_show ? 'click' : ''"
        :class="$store.state.user.permissions.member_show ? '' : 'disabled'">
          <div class="icon">
            <font-icon icon="user" />
          </div>
          <span>Mitglieder</span>
        </router-link>
      </li>
      <li>
        <router-link to="/docs"
        :event="$store.state.user.permissions.dokumente_show ? 'click' : ''"
        :class="$store.state.user.permissions.dokumente_show ? '' : 'disabled'">
          <div class="icon">
            <font-icon icon="file-alt" />
          </div>
          <span>Dokumente</span>
        </router-link>
      </li>
      <li>
        <router-link to="/smsservice"
        :event="$store.state.user.permissions.sms_show ? 'click' : ''"
        :class="$store.state.user.permissions.sms_show ? '' : 'disabled'">
          <div class="icon">
            <font-icon icon="sms" />
          </div>
          <span>SMS-Service</span>
        </router-link>
      </li>
      <li>
        <router-link to="/user"
        :event="$store.state.user.permissions.user_show ? 'click' : ''"
        :class="$store.state.user.permissions.user_show ? '' : 'disabled'">
          <div class="icon">
            <font-icon icon="user-cog" />
          </div>
          <span>Benutzer</span>
        </router-link>
      </li>
      <!-- <li>
        <router-link to="/settings"
        :event="$store.state.user.permissions.settings_show ? 'click' : ''"
        :class="$store.state.user.permissions.settings_show ? '' : 'disabled'">
          <div class="icon">
            <font-icon icon="sliders-h" />
          </div>
          <span>Einstellungen</span>
        </router-link>
      </li> -->
      <li>
        <router-link to="/security"
        :event="$store.state.user.permissions.security_show ? 'click' : ''"
        :class="$store.state.user.permissions.security_show ? '' : 'disabled'">
          <div class="icon">
            <font-icon icon="shield-alt" />
          </div>
          <span>Sicherheit</span>
        </router-link>
      </li>
      <li>
        <router-link to="/profil">
          <div class="icon">
            <div class="dot">{{shortProfilName}}</div>
          </div>
          <span>Profil</span>
        </router-link>
      </li>
      <li>
        <a @click="clicked('logout')">
          <div class="icon">
            <font-icon icon="power-off" />
          </div>
          <span>Logout</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import EventBus from "../bus";

export default {
  name: "jhmenu",
  data() {
    return {
      status: 0,
      menuinput: ''
    };
  },
  mounted: function() {
    EventBus.$on("resetMenuInput", (item) => {
      this.menuinput = ''
    });

  },
  updated: function() {},
  computed: {
    classLeftBar: function() {
      return {
        leftbar: true,
        close: this.status == 0,
        open: this.status == 1
      };
    },
    shortProfilName: function(){
      var returnValue = ""
      if( this.$store.state.user.prename.length > 0 ){
        returnValue += this.$store.state.user.prename[0]
      }
      if( this.$store.state.user.familyname.length > 0 ){
        returnValue += this.$store.state.user.familyname[0]
      }
      return returnValue
    }
  },
  methods: {
    switchShow: function() {
      if (this.status == 0) {
        this.status = 1;
      } else {
        this.status = 0;
      }
    },
    mouseOverLeftBar: function() {
      this.status = 1;
    },
    mouseLeaveLeftBar: function() {
      this.status = 0;
    },
    clicked(eventName, item){
      EventBus.$emit(eventName, item);
    }
  }
};
</script>


<style>
.topbar {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  font-size: 13px;
  border-bottom: 1px solid #c7c7c7;
  display: flex;
  justify-content: space-between;
  background-color: #f2f2f2;
  -webkit-box-shadow: 3px 7px 12px -12px rgba(179, 179, 179, 1);
  -moz-box-shadow: 3px 7px 12px -12px rgba(179, 179, 179, 1);
  box-shadow: 3px 7px 12px -12px rgba(179, 179, 179, 1);
}
.left {
  display: flex;
}
.left span{
  display: flex;
  align-items: center; 
  font-size: 16px;
  font-weight: bold; 
  padding-left: 15px;  
}
#show-menu,
.leftbar li div.icon {
  cursor: pointer;
  height: 40px;
  width: 39px;
  display: flex;
  flex: initial;
  align-items: center;
  justify-content: center;
  font-size: 17px;
}

li a{
  cursor: pointer;
}

.leftbar {
  position: fixed;
  z-index: 1000;
  top: 40px;
  left: 0;
  display: block;
  width: 40px;
  height: 100%;
  background-color: #f2f2f2;
  margin: 0;
  border-right: 1px solid #c7c7c7;
  border-bottom: 1px solid #c7c7c7;
  overflow: hidden;
  -webkit-transition: width 0.2s;
  -moz-transition: width 0.2s;
  transition: width 0.2s;
  transition-delay: 350ms;
  -webkit-box-shadow: 7px 0 12px -12px rgba(179, 179, 179, 1);
  -moz-box-shadow: 7px 0 12px -12px rgba(179, 179, 179, 1);
  box-shadow: 7px 0 12px -12px rgba(179, 179, 179, 1);
}

.leftbar li {
  display: block;
  margin: 0;
  color: #333;
}
.leftbar li {
  border-bottom: 1px solid #c7c7c7;
}
.leftbar li a:hover,
#show-menu:hover {
  background-color: #1f8cc4 ;
  color: white;
}
.leftbar li a:hover .dot{
  background-color:white ;
  color: #1f8cc4;
}

.leftbar li a.disabled{
  color: #919191;
}
.leftbar li a.disabled:hover{
  background-color: transparent;
  color: #919191;
  cursor: default;
}

.leftbar li a.disabled div{
  cursor: default;
}

.leftbar li a {
  display: flex;
  text-decoration: none;
}
.leftbar li span {
  flex: 1;
  display: flex;
  align-items: center;
  font-size: 13px;
  width: 0;
  white-space: nowrap;
}

.leftbar li:last-child {
  position: absolute;
  bottom: 38px;
  left: 0;
  right: 0;
}

.leftbar li:nth-last-child(2){
  position: absolute;
  bottom: 79px;
  left: 0;
  right: 0;
  border-top: 1px solid #c7c7c7;  
}

.leftbar.open {
  width: 200px;
  -webkit-transition: width 0.2s;
  -moz-transition: width 0.2s;
  transition: width 0.2s;
  transition-delay: 250ms;
}
.dot {
  height: 20px;
  width: 20px;
  background-color: #35495E;
  border-radius: 50%;
  color: #f2f2f2;
  font-weight: bold;
  font-size: 11px;
  align-items: center;
  justify-content: center;
  display: flex;
}
input.search, input.menuinput{
  border: none;
  border-left: 1px solid #c7c7c7;
  height: 100%;
  width: 220px;
}
.bar button{
  background-color: #1F8CC4;
  height: 100%;
  width: 40px;
  border: none;
  border-left: 1px solid #c7c7c7;
  color: white;
  font-size: 1.1rem;
  cursor: pointer;
  float: left;
}
.bar button:hover{
  background-color: #239cda;
}
.right.bar{
  display: flex;
}
a.router-link-active{
  background-color:  #1F8CC4;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Menu.vue